/* The Charm Lab — storefront behaviour.
   Deliberately small: the header menu, the bag drawer, add-to-cart, and the
   toast. Everything that can be rendered by Liquid is rendered by Liquid; this
   file only moves things around and asks Shopify to re-render the bag. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var routes = window.themeRoutes || {};

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 3200);
  }

  /* ---------- scrim, drawers ---------- */
  var scrim = $('#scrim');

  function closeAll() {
    var m = $('#mobmenu'), c = $('#cart');
    if (m) m.classList.remove('open');
    if (c) c.classList.remove('open');
    if (scrim) scrim.classList.remove('on');
    document.body.style.overflow = '';
    var b = $('#burger');
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  function openCart() {
    var c = $('#cart');
    if (!c) return;
    c.classList.add('open');
    if (scrim) scrim.classList.add('on');
    document.body.style.overflow = 'hidden';
  }

  /* ---------- mobile menu, built from the desktop nav ---------- */
  function buildMobMenu() {
    var mob = $('#mobmenu');
    var nav = $('#navlinks');
    if (!mob || !nav || mob.dataset.built) return;

    var html = '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;gap:12px">'
      + '<a href="' + (routes.root_url || '/') + '" aria-label="Home">'
      + (function () { var l = $('.logo-svg'); return l ? '<img class="logo-svg" src="' + l.getAttribute('src') + '" alt="">' : ''; })()
      + '</a>'
      + '<button class="iconbtn" id="mobClose" aria-label="Close menu">'
      + '<svg viewBox="0 0 24 24" style="width:18px;height:18px;stroke:currentColor;fill:none;stroke-width:1.4">'
      + '<path d="M5 5l14 14M19 5L5 19"/></svg></button></div>';

    $$('.navitem, a.navtop', nav).forEach(function (node) {
      if (node.classList.contains('navitem')) {
        var label = $('.navtop', node);
        html += '<div class="grp">' + (label ? label.textContent.trim() : '') + '</div>';
        $$('.dropdown a', node).forEach(function (a) {
          html += '<a href="' + a.getAttribute('href') + '">' + a.textContent.trim() + '</a>';
        });
      } else {
        html += '<a href="' + node.getAttribute('href') + '">' + node.textContent.trim() + '</a>';
      }
    });

    mob.innerHTML = html;
    mob.dataset.built = '1';
  }

  /* ---------- re-render the bag from Liquid ---------- */
  function refreshCart() {
    return fetch((routes.root_url || '/') + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var markup = data['cart-drawer'];
        if (!markup) return;
        var doc = new DOMParser().parseFromString(markup, 'text/html');
        var items = $('#cartItems'), foot = $('#cartFoot');
        var newItems = $('#cartItems', doc), newFoot = $('#cartFoot', doc);
        if (items && newItems) items.innerHTML = newItems.innerHTML;
        if (foot && newFoot) foot.innerHTML = newFoot.innerHTML;
      })
      .then(function () { return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var badge = $('#cartCount');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count ? 'grid' : 'none';
        }
      })
      .catch(function () {});
  }

  /* ---------- add to cart ---------- */
  function addToCart(payload, label) {
    return fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.body && res.body.description ? res.body.description : 'Sorry — that could not be added.');
          return false;
        }
        return refreshCart().then(function () {
          openCart();
          toast((label || 'Added') + ' — in your bag.');
          return true;
        });
      })
      .catch(function () { toast('Could not reach the bag. Check your connection.'); return false; });
  }

  window.charmLabAddToCart = addToCart;
  window.charmLabToast = toast;
  window.charmLabRefreshCart = refreshCart;

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var hit = function (sel) { return t.closest ? t.closest(sel) : null; };

    /* the mixed-metal warning owns every click while it is open */
    if (hit('[data-mixwarn]')) {
      if (hit('[data-mixwarn-ok]')) { e.preventDefault(); confirmMix(); return; }
      if (hit('[data-mixwarn-cancel]') || !hit('.mixwarn__box')) { e.preventDefault(); closeMixWarn(); return; }
      return;
    }

    /* nav dropdowns */
    var top = hit('.has-menu .navtop');
    if (top) {
      var item = top.parentElement;
      var wasOpen = item.classList.contains('open');
      $$('.navitem.open').forEach(function (x) {
        x.classList.remove('open');
        var b = $('.navtop', x); if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) { item.classList.add('open'); top.setAttribute('aria-expanded', 'true'); }
      e.preventDefault();
      return;
    }
    if (!hit('.dropdown')) {
      $$('.navitem.open').forEach(function (x) {
        x.classList.remove('open');
        var b = $('.navtop', x); if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    if (hit('#burger')) {
      buildMobMenu();
      $('#mobmenu').classList.add('open');
      if (scrim) scrim.classList.add('on');
      document.body.style.overflow = 'hidden';
      $('#burger').setAttribute('aria-expanded', 'true');
      return;
    }
    if (hit('#mobClose') || hit('#scrim') || hit('#cartClose') || hit('[data-closecart]')) {
      if (hit('[data-closecart]') && !hit('#cartClose')) { closeAll(); return; }
      closeAll();
      if (hit('#cartClose') || hit('#scrim') || hit('#mobClose')) e.preventDefault();
      return;
    }
    if (hit('#cartBtn')) { openCart(); return; }

    /* quantity steppers in the bag */
    var qty = hit('[data-qty]');
    if (qty) {
      var key = qty.getAttribute('data-qty');
      var delta = parseInt(qty.getAttribute('data-d'), 10);
      var row = qty.closest('.qtybox');
      var current = parseInt($('span', row).textContent.trim(), 10) || 0;
      var next = Math.max(0, current + delta);
      qty.disabled = true;
      fetch(routes.cart_change_url || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      }).then(function () { return refreshCart(); })
        .catch(function () { toast('Could not update the bag.'); });
      return;
    }

    /* quick add buttons on cards */
    var quick = hit('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      addToCart({ items: [{ id: parseInt(quick.getAttribute('data-quick-add'), 10), quantity: 1 }] },
        quick.getAttribute('data-quick-label'));
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (mixWarnOpen()) { closeMixWarn(); return; }
    closeAll();
  });

  /* localization selects submit their own form */
  $$('[data-localization-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var form = sel.closest('form');
      if (form) form.submit();
    });
  });


  /* ---------- money ---------- */
  function money(cents) {
    var fmt = window.themeMoneyFormat || '{{amount}}';
    var n = (cents / 100);
    var noDecimals = /amount_no_decimals/.test(fmt);
    var s = noDecimals
      ? Math.round(n).toLocaleString('en-US')
      : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, s);
  }
  window.charmLabMoney = money;

  /* ---------- product page ---------- */
  function productForm(el) { return el.closest ? el.closest('[data-product-form]') : null; }

  function readVariants(form) {
    var tag = form.querySelector('[data-variants]');
    if (!tag) return [];
    try { return JSON.parse(tag.textContent) || []; } catch (e) { return []; }
  }

  function selectedOptions(form) {
    var out = [];
    $$('.optbtn[data-opt].on', form).forEach(function (b) {
      out[parseInt(b.getAttribute('data-opt'), 10)] = b.getAttribute('data-value');
    });
    /* long option lists render as a dropdown rather than a row of buttons */
    $$('select.optsel[data-opt]', form).forEach(function (sel) {
      out[parseInt(sel.getAttribute('data-opt'), 10)] = sel.value;
    });
    return out;
  }

  /* ---------- metals ----------
     Gold and silver are the only two finishes we sell, and every charm and
     every chain is one or the other. A piece can be built across both — some
     people want that — but it has to be on purpose, so the charm row follows
     the chain unless someone overrides it, and an override has to be
     acknowledged before it reaches the bag. */
  function readMetal(text) {
    var s = String(text || '').toLowerCase();
    if (s.indexOf('gold') > -1) return 'Gold';
    if (s.indexOf('silver') > -1) return 'Silver';
    return '';
  }

  function chainMetal(form, match) {
    var m = match ? readMetal((match.options || []).join(' ') || match.title) : '';
    if (m) return m;
    var found = '';
    selectedOptions(form).forEach(function (val) {
      var v = readMetal(val);
      if (v) found = v;
    });
    return found;
  }

  function lc(metal) { return metal === 'Gold' ? 'gold' : 'silver'; }
  function otherMetal(metal) { return metal === 'Gold' ? 'Silver' : 'Gold'; }

  /* Point every charm button at the variant of the metal we want, falling back
     to the metal it does have if that charm is only made in one. Returns the
     charms that ended up on the wrong metal AND are actually selected. */
  function applyCharmMetal(form, chain) {
    var picker = form.querySelector('[data-charmpicker]');
    if (!picker) return [];

    var chooser = picker.querySelector('[data-charm-metal]');
    var want = form.getAttribute('data-charm-metal') || '';
    if (!want) want = chain;
    if (!want) {
      /* no metal option on this chain — leave the row exactly as Liquid built it */
      if (chooser) chooser.hidden = true;
      return [];
    }
    if (chooser) {
      chooser.hidden = false;
      $$('[data-charm-metal-btn]', chooser).forEach(function (b) {
        b.classList.toggle('on', b.getAttribute('data-charm-metal-btn') === want);
      });
      var note = chooser.querySelector('[data-charm-metal-note]');
      if (note) {
        if (chain && want !== chain) {
          note.hidden = false;
          note.textContent = want + ' charms on a ' + chain.toLowerCase() + ' chain — we will ask you to confirm the mix.';
        } else {
          note.hidden = true;
          note.textContent = '';
        }
      }
    }

    var mismatched = [];
    $$('.charmpick', picker).forEach(function (b) {
      var used = want;
      var id = b.getAttribute('data-' + lc(want) + '-id');
      if (!id) { used = otherMetal(want); id = b.getAttribute('data-' + lc(used) + '-id'); }
      if (!id) { b.setAttribute('data-mismatch', '0'); return; }

      b.setAttribute('data-charm', id);
      b.setAttribute('data-charm-metal', used);

      var price = parseInt(b.getAttribute('data-' + lc(used) + '-price') || '', 10);
      if (!isNaN(price)) b.setAttribute('data-charm-price', String(price));

      var img = b.getAttribute('data-' + lc(used) + '-img');
      var el = b.querySelector('[data-charm-img]');
      if (el && img && el.getAttribute('src') !== img) el.setAttribute('src', img);

      var name = b.getAttribute('data-charm-name') || 'Charm';
      b.setAttribute('title', name + ' · ' + used + (isNaN(price) ? '' : ' · ' + money(price)));

      var bad = !!(chain && used !== chain);
      b.setAttribute('data-mismatch', bad ? '1' : '0');

      var q = parseInt(b.getAttribute('data-qty') || '0', 10);
      if (bad && q > 0) mismatched.push({ name: name, metal: used, qty: q });
    });

    return mismatched;
  }

  function charmState(form) {
    var picker = form.querySelector('[data-charmpicker]');
    var map = {};
    if (!picker) return map;
    $$('.charmpick', picker).forEach(function (b) {
      var q = parseInt(b.getAttribute('data-qty') || '0', 10);
      if (q > 0) map[b.getAttribute('data-charm')] = { qty: q, price: parseInt(b.getAttribute('data-charm-price'), 10) || 0 };
    });
    return map;
  }

  function syncProduct(form) {
    if (!form) return;
    var variants = readVariants(form);
    var chosen = selectedOptions(form);
    var match = null;
    variants.forEach(function (v) {
      if (match) return;
      var ok = true;
      chosen.forEach(function (val, i) { if (val != null && v.options[i] !== val) ok = false; });
      if (ok) match = v;
    });
    if (!match) match = variants[0];
    if (!match) return;

    var idField = form.querySelector('[data-variant-id]');
    if (idField) idField.value = match.id;

    /* the code above the title is the variant's own SKU, so it has to follow
       the metal: CL-G-TEDBEA on Gold, CL-S-TEDBEA on Silver. Liquid prints the
       first available variant's SKU, which is only right until something is
       picked. A variant with no SKU of its own is left alone — the Liquid
       fallback there is the product type, not a code. */
    var skuEl = form.parentNode.querySelector('[data-sku]');
    if (skuEl && match.sku) skuEl.textContent = match.sku;

    /* every letter, month and sign has its own photograph — follow the variant */
    var vImg = match.featured_image && match.featured_image.src;
    if (vImg) {
      var mainWrap = document.querySelector('[data-main-image]');
      var mainImg = mainWrap && mainWrap.querySelector('img');
      if (mainImg && mainImg.src.split('?')[0] !== String(vImg).split('?')[0]) {
        mainImg.src = vImg;
        mainImg.removeAttribute('srcset');
        if (match.featured_image.alt) mainImg.alt = match.featured_image.alt;
      }
    }

    $$('select.optsel[data-opt]', form).forEach(function (sel) {
      var lab = form.querySelector('[data-opt-label="' + sel.getAttribute('data-opt') + '"]');
      if (lab) lab.textContent = sel.value;
    });

    /* the charm row has to be pointed at the right metal BEFORE the totals are
       added up, because gold and silver charms are not the same price */
    var chain = chainMetal(form, match);
    if (chain) form.setAttribute('data-chain-metal', chain);
    form.__mix = applyCharmMetal(form, chain);

    var charms = charmState(form);
    var charmTotal = 0, charmCount = 0, items = [];
    Object.keys(charms).forEach(function (id) {
      charmCount += charms[id].qty;
      charmTotal += charms[id].qty * charms[id].price;
      items.push({ id: parseInt(id, 10), quantity: charms[id].qty });
    });

    var extra = form.querySelector('[data-extra-items]');
    if (extra) extra.value = items.length ? JSON.stringify(items) : '';

    var total = match.price + charmTotal;
    var priceEl = form.parentNode.querySelector('[data-price]');
    if (priceEl) priceEl.textContent = money(match.price);
    var totalEl = form.querySelector('[data-total]');
    if (totalEl) totalEl.textContent = money(total);

    var note = form.parentNode.querySelector('[data-price-note]');
    if (note) {
      note.textContent = charmCount
        ? money(match.price) + ' chain + ' + charmCount + ' charm' + (charmCount > 1 ? 's' : '')
        : 'Chain only — add charms below';
    }

    var summary = form.querySelector('[data-charm-summary]');
    if (summary) summary.textContent = charmCount + ' selected · ' + money(charmTotal);
    var clear = form.querySelector('[data-charm-clear]');
    if (clear) clear.hidden = charmCount === 0;

    /* a chain is only sold as a finished piece, so it needs at least one charm */
    var needsCharm = form.hasAttribute('data-requires-charm') && charmCount === 0;

    var submit = form.querySelector('button[type="submit"]');
    if (submit && !submit.hasAttribute('data-keep-label')) {
      if (!match.available) {
        submit.disabled = true;
        submit.textContent = 'Sold out';
      } else if (needsCharm) {
        submit.disabled = true;
        submit.textContent = 'Choose at least one charm';
      } else {
        submit.disabled = false;
        submit.innerHTML = 'Add to bag · <span data-total>' + money(total) + '</span>';
      }
    }
  }

  /* variant option dropdowns (Month, Sign, Letter, Number) */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('select.optsel[data-opt]') : null;
    if (!sel) return;
    var f = productForm(sel);
    if (f) syncProduct(f);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest && t.closest('[data-mixwarn]')) return;
    var hit = function (sel) { return t.closest ? t.closest(sel) : null; };

    /* gallery thumbnails */
    var thumb = hit('[data-thumb]');
    if (thumb) {
      var gallery = thumb.closest('.gallery');
      var main = gallery && gallery.querySelector('[data-main-image] img');
      if (main) {
        main.src = thumb.getAttribute('data-src');
        main.srcset = thumb.getAttribute('data-srcset') || '';
        main.alt = thumb.getAttribute('data-alt') || '';
      }
      $$('[data-thumb]', gallery).forEach(function (b) { b.classList.remove('on'); });
      thumb.classList.add('on');
      return;
    }

    /* variant option buttons */
    var opt = hit('.optbtn[data-opt]');
    if (opt) {
      var form = productForm(opt);
      if (!form) return;
      var group = opt.getAttribute('data-opt');
      $$('.optbtn[data-opt="' + group + '"]', form).forEach(function (b) { b.classList.remove('on'); });
      opt.classList.add('on');
      var label = form.querySelector('[data-opt-label="' + group + '"]');
      if (label) label.textContent = opt.getAttribute('data-value');
      /* changing the chain's metal drops any charm-metal override, so the row
         goes back to matching the chain rather than silently staying mixed */
      if (readMetal(opt.getAttribute('data-value'))) form.removeAttribute('data-charm-metal');
      syncProduct(form);
      return;
    }

    /* the Gold / Silver chooser above the charm row */
    var cm = hit('[data-charm-metal-btn]');
    if (cm) {
      var cmForm = productForm(cm);
      if (!cmForm) return;
      cmForm.setAttribute('data-charm-metal', cm.getAttribute('data-charm-metal-btn'));
      syncProduct(cmForm);
      return;
    }

    /* line-item property buttons (length) */
    var prop = hit('.optbtn[data-prop]');
    if (prop) {
      var pform = productForm(prop);
      if (!pform) return;
      var name = prop.getAttribute('data-prop');
      $$('.optbtn[data-prop="' + name + '"]', pform).forEach(function (b) { b.classList.remove('on'); });
      prop.classList.add('on');
      var pLabel = pform.querySelector('[data-prop-label="' + name + '"]');
      if (pLabel) pLabel.textContent = prop.getAttribute('data-value');
      var input = pform.querySelector('[data-prop-input="' + name + '"]');
      if (input) input.value = prop.getAttribute('data-value');
      return;
    }

    /* charm quick-picker on the product page */
    var pick = hit('.charmpick');
    if (pick) {
      var cform = productForm(pick);
      if (!cform) return;
      var q = parseInt(pick.getAttribute('data-qty') || '0', 10);
      q = e.shiftKey ? Math.max(0, q - 1) : q + 1;
      pick.setAttribute('data-qty', q);
      pick.classList.toggle('on', q > 0);
      var badge = pick.querySelector('.qty');
      if (q > 0) {
        if (!badge) { badge = document.createElement('i'); badge.className = 'qty'; pick.appendChild(badge); }
        badge.textContent = q;
      } else if (badge) { badge.remove(); }
      syncProduct(cform);
      return;
    }

    if (hit('[data-charm-clear]')) {
      var clForm = productForm(t);
      if (!clForm) return;
      $$('.charmpick', clForm).forEach(function (b) {
        b.setAttribute('data-qty', '0');
        b.classList.remove('on');
        var bd = b.querySelector('.qty'); if (bd) bd.remove();
      });
      syncProduct(clForm);
      return;
    }

    /* accordion tabs */
    var tabBtn = hit('.tab > button');
    if (tabBtn) {
      tabBtn.parentNode.classList.toggle('open');
      return;
    }
  });

  $$('[data-product-form]').forEach(syncProduct);

  /* ---------- the mixed-metal warning ---------- */
  var mixForm = null;
  var mixLastFocus = null;

  function mixBox() { return $('[data-mixwarn]'); }
  function mixWarnOpen() { var b = mixBox(); return !!(b && !b.hidden); }

  function openMixWarn(form, list) {
    var box = mixBox();
    if (!box) { submitProduct(form); return; }   /* fail open rather than trap the sale */

    var chain = form.getAttribute('data-chain-metal') || '';
    var body = box.querySelector('[data-mixwarn-body]');
    var ul = box.querySelector('[data-mixwarn-list]');
    var pieces = list.reduce(function (n, m) { return n + m.qty; }, 0);

    if (body) {
      body.textContent = 'Your chain is ' + (chain ? chain.toLowerCase() : 'one metal') + ', and '
        + (pieces === 1 ? 'one of the charms you have chosen is' : pieces + ' of the charms you have chosen are')
        + ' the other metal:';
    }
    if (ul) {
      ul.innerHTML = '';
      list.forEach(function (m) {
        var li = document.createElement('li');
        li.textContent = m.name + ' — ' + m.metal + (m.qty > 1 ? ' × ' + m.qty : '');
        ul.appendChild(li);
      });
    }

    mixForm = form;
    mixLastFocus = document.activeElement;
    box.hidden = false;
    document.body.style.overflow = 'hidden';
    var ok = box.querySelector('[data-mixwarn-ok]');
    if (ok && ok.focus) ok.focus();
  }

  function closeMixWarn() {
    var box = mixBox();
    if (box) box.hidden = true;
    document.body.style.overflow = '';
    mixForm = null;
    if (mixLastFocus && mixLastFocus.focus) mixLastFocus.focus();
    mixLastFocus = null;
  }

  function confirmMix() {
    var form = mixForm;
    closeMixWarn();
    if (!form) return;
    form.setAttribute('data-mix-ok', '1');
    submitProduct(form);
    form.removeAttribute('data-mix-ok');
  }

  /* ---------- product forms ---------- */
  function submitProduct(form) {
    var id = form.querySelector('[name="id"]');
    if (!id) return;
    var qtyField = form.querySelector('[name="quantity"]');
    var props = {};
    $$('[name^="properties["]', form).forEach(function (f) {
      var m = f.name.match(/properties\[(.+)\]/);
      if (m && f.value) props[m[1]] = f.value;
    });
    var extra = form.querySelector('[data-extra-items]');
    var item = { id: parseInt(id.value, 10), quantity: qtyField ? parseInt(qtyField.value, 10) || 1 : 1 };
    var items = [item];
    if (extra && extra.value) {
      var build = 'b' + Date.now().toString(36);
      props._build = build;
      try {
        JSON.parse(extra.value).forEach(function (x) {
          items.push({ id: x.id, quantity: x.quantity, properties: { _build: build } });
        });
      } catch (err) {}
    }
    if (Object.keys(props).length) item.properties = props;
    addToCart({ items: items }, form.getAttribute('data-label'));
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault();

    var extra = form.querySelector('[data-extra-items]');
    if (form.hasAttribute('data-requires-charm') && !(extra && extra.value)) {
      toast('Every piece is built with at least one charm — pick one below and we will fit it.');
      var picker = form.querySelector('[data-charmpicker]');
      if (picker && picker.scrollIntoView) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    /* gold on silver, or silver on gold: allowed, but only knowingly */
    var mix = form.__mix || [];
    if (mix.length && form.getAttribute('data-mix-ok') !== '1') {
      openMixWarn(form, mix);
      return;
    }

    submitProduct(form);
  });
})();